exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".person-card{box-shadow:0px 1px 2px rgba(0,0,0,.1607843137);border-radius:8px;padding:25px;background-color:#fff;margin:20px 0px 20px 0px}.person-card #person-image{padding:4px;height:45px;border-radius:50%;-moz-border-radius:50%;-webkit-border-radius:50%;width:48px;vertical-align:middle;margin-right:15px}.person-card .person-info{margin-left:10px}.person-card .person-info #person-info-head h4.person-name{font-size:1.3rem;overflow:hidden;text-overflow:ellipsis;margin-right:5px}.person-card .person-icon-div .personIcons{float:right}.person-card .person-icon-div .personIcons .disabled-link{pointer-events:none}.person-card .person-icon-div .personIcons .person-menu-icon{cursor:pointer}.person-card #person-role{font-size:12px;color:#92929d}.person-card #person-description{color:#92929d;font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/ActivityCenter/SubComponents/CaseDetailsPersonCard.scss
// module id = 7422
// module chunks = 101